/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCopilotGovernanceMetricsProcessor extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCopilotGovernanceMetricsProcessor");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCopilotGovernanceMetricsProcessor>): BackgroundJobPayloadForCopilotGovernanceMetricsProcessor {
        let obj = Object.assign(new BackgroundJobPayloadForCopilotGovernanceMetricsProcessor(), model);
        BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCopilotGovernanceMetricsProcessor>): BackgroundJobPayloadForCopilotGovernanceMetricsProcessor {
        if (!model) return null;
        return BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.newInstance(<BackgroundJobPayloadForCopilotGovernanceMetricsProcessor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCopilotGovernanceMetricsProcessor) {
        if (!obj) return;

        models.BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCopilotGovernanceMetricsProcessor): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.backfill_start_date === "string") {
            this.backfill_start_date = new Date(<string><any>this.backfill_start_date);
        }
        if (typeof this.backfill_end_date === "string") {
            this.backfill_end_date = new Date(<string><any>this.backfill_end_date);
        }
    }

    /**
     * Service account ID to which the Copilot data has to be synced
     */
    service_account_id: string;

    /**
     * Start of the custom date range to backfill Copilot metrics for (inclusive). When set together with backfill_end_date, the processor deletes and re-fetches metrics per-day for this range instead of the default 28-day sync.
     */
    backfill_start_date: Date;

    /**
     * End of the custom date range to backfill Copilot metrics for (exclusive)
     */
    backfill_end_date: Date;

}
